{
  "dropLabel": "किसी विशेष प्रश्न पर जाएं",
  "nextLabel": "<b>स्वास्थ्य से जुड़े प्रश्नों के उत्तर दें</b>",
  "questions": {
    "allergies": {
      "detailsPlaceholder": "कृपया अंग्रेज़ी में भरें। उदाहरण के लिए:<br/>\nPenicillin – rash and swelling; Latex – mild irritation",
      "label": "क्या आपको कोई एलर्जी है?",
      "nextLabel": "$t(common:next): <b>वजन और कद</b>",
      "title": "<h3>एलर्जी (Allergies)</h3>"
    },
    "arrhythmias": {
      "detailsPlaceholder": "कृपया अंग्रेज़ी में भरें। उदाहरण के लिए: <br/>Irregular heartbeat, on beta blockers since 2021",
      "label": "क्या आपको अनियमित दिल की धड़कन, धड़कन का अनुभव, या दिल में मर्मर है?",
      "nextLabel": "$t(common:next): <b>पेसमेकर</b>",
      "title": "<h3>अरिध्मिया (अनियमित हृदय गति) (Arrhythmias)</h3>"
    },
    "asthmaLungConditions": {
      "detailsPlaceholder": "कृपया अंग्रेज़ी में भरें। उदाहरण के लिए:<br/>\nMild asthma – use inhaler occasionally",
      "label": "क्या आपको अस्थमा, सीओपीडी या कोई अन्य फेफड़ों की बीमारी है?",
      "nextLabel": "$t(common:next): <b>पाचन संबंधी स्थितियां</b>",
      "title": "<h3>अस्थमा या फेफड़ों की बीमारियां (Asthma or lung conditions)</h3>"
    },
    "bloodProblems": {
      "detailsPlaceholder": "कृपया अंग्रेज़ी में भरें। उदाहरण के लिए: <br/>\nEasy bruising – diagnosed with Von Willebrand disease",
      "label": "क्या आपको जीओआरडी (रिफ्लक्स), आईबीएस, या आईबीडी है?",
      "nextLabel": "$t(common:next): <b>अंग प्रतिरोपण</b>",
      "title": "<h3>रक्त विकार या रक्तस्राव की समस्याएं (Blood disorders or bleeding problems)</h3>"
    },
    "bloodThinningMedication": {
      "detailsPlaceholder": "कृपया अंग्रेज़ी में भरें। उदाहरण के लिए: <br/>Apixaban – 5mg daily, last taken on 3 June",
      "label": "क्या आप वर्तमान में कोई रक्त पतला करने वाली दवा ले रहे हैं?",
      "nextLabel": "$t(common:next): <b>हृदय संबंधी समस्याएं</b>",
      "title": "<h3>खून पतला करने वाली दवा (Blood thinning medication)</h3>"
    },
    "cancerTreatment": {
      "detailsPlaceholder": "कृपया अंग्रेज़ी में भरें। उदाहरण के लिए: <br/>\nChemotherapy for breast cancer – ongoing",
      "label": "क्या आप वर्तमान में कीमोथेरेपी, रेडियोथेरेपी या कैंसर का कोई अन्य उपचार प्राप्त कर रहे हैं?",
      "nextLabel": "$t(common:next): <b>संक्रामक रोग</b>",
      "title": "<h3>कैंसर का इलाज (Cancer treatment)</h3>"
    },
    "diabetes": {
      "detailsLabel": "आपका मधुमेह कैसे प्रबंधित किया जाता है?",
      "diet-controlled": "आहार से नियंत्रित",
      "insulin": "इंसुलिन",
      "label": "क्या आपको मधुमेह है?",
      "nextLabel": "$t(common:next): <b>उच्च रक्तचाप</b>",
      "no": "नहीं",
      "tablets": "टैबलेट्स (जैसे Metformin)",
      "title": "<h3>मधुमेह (Diabetes)</h3>",
      "type-1": "टाइप 1 – इंसुलिन पर",
      "type-2": "टाइप 2",
      "yes-type-1": "हाँ – टाइप 1, इंसुलिन पर",
      "yes-type-2": "हाँ – टाइप 2"
    },
    "digestiveConditions": {
      "detailsPlaceholder": "कृपया अंग्रेज़ी में भरें। उदाहरण के लिए:<br/>Reflux managed with omeprazole",
      "label": "क्या आपको जीओआरडी (रिफ्लक्स), आईबीएस, या आईबीडी है?",
      "nextLabel": "$t(common:next): <b>रक्त या रक्तस्राव से जुड़ी समस्याएं</b>",
      "title": "<h3>पाचन संबंधी समस्याएं (Digestive conditions)</h3>"
    },
    "epilepsy": {
      "detailsPlaceholder": "कृपया अंग्रेज़ी में भरें। उदाहरण के लिए:<br/>\nLast seizure in 2020 – currently stable",
      "label": "क्या आपको मिर्गी है या दौरे पड़ने का कोई इतिहास है?",
      "nextLabel": "$t(common:next): <b>तंत्रिका संबंधी स्थितियां</b>",
      "title": "<h3>मिर्गी (Epilepsy)</h3>"
    },
    "heartConditions": {
      "detailsPlaceholder": "कृपया अंग्रेज़ी में भरें। उदाहरण के लिए: <br/>Heart attack in 2020 – stent inserted",
      "label": "क्या आपको कभी कोई हृदय संबंधी बीमारी रही है (जैसे दिल का दौरा, एनजाइना)?",
      "nextLabel": "$t(common:next): <b>स्ट्रोक या टीआईए</b>",
      "title": "<h3>हृदय संबंधी समस्याएं (Heart conditions)</h3>"
    },
    "highBloodPressure": {
      "detailsPlaceholder": "कृपया अंग्रेज़ी में भरें। उदाहरण के लिए: <br/>\nDiagnosed in 2018 – managed with medication",
      "label": "क्या आपको उच्च रक्तचाप है?",
      "nextLabel": "$t(common:next): <b>अनियमित हृदय गति</b>",
      "title": "<h3>उच्च रक्तचाप (High blood pressure)</h3>"
    },
    "infectiousDiseases": {
      "detailsPlaceholder": "कृपया अंग्रेज़ी में भरें। उदाहरण के लिए: <br/>MRSA – cleared after treatment in 2021",
      "label": "क्या आपने कभी MRSA, ESBL, VRE या CPE के लिए पॉजिटिव परीक्षण किया है?",
      "nextLabel": "$t(common:next): <b>गर्भावस्था</b>",
      "title": "<h3>मल्टी-रेज़िस्टेंट जीवाणु (Multi-resistant organisms)</h3>"
    },
    "metalImplants": {
      "detailsPlaceholder": "कृपया अंग्रेज़ी में भरें। उदाहरण के लिए: <br/>Right hip replacement (2020), dental implants, or metal rod in leg",
      "label": "क्या आपके शरीर में कोई धातु प्रत्यारोपण या धातु उपकरण है? (जैसे पेसमेकर या कृत्रिम अंग)",
      "nextLabel": "$t(common:next): <b>मधुमेह</b>",
      "title": "<h3>इम्प्लांट्स या धातु (Implants or metal)</h3>"
    },
    "obstructiveSleepApnoea": {
      "detailsPlaceholder": "कृपया अंग्रेज़ी में भरें। उदाहरण के लिए:<br/>\nDiagnosed in 2022 – use CPAP machine every night",
      "label": "क्या आपको ऑब्सट्रक्टिव स्लीप एपनिया है या क्या आप रात को सोते समय CPAP मशीन का उपयोग करते हैं?",
      "nextLabel": "$t(common:next): <b>दमा या फेफड़ों की स्थितियाँ</b>",
      "title": "<h3>ऑब्स्ट्रक्टिव स्लीप एपनिया (Obstructive Sleep Apnoea)</h3>"
    },
    "organTransplant": {
      "detailsPlaceholder": "कृपया अंग्रेज़ी में भरें। उदाहरण के लिए: <br/>\nKidney transplant in 2018 – taking tacrolimus and prednisone",
      "label": "क्या आपने अंग प्रतिरोपण करवाया है और क्या आप इम्यूनोप्रेसिव दवाएं ले रहे हैं?",
      "nextLabel": "$t(common:next): <b>कैंसर का उपचार</b>",
      "title": "<h3>अंग प्रत्यारोपण (Organ transplant)</h3>"
    },
    "otherHealthConditions": {
      "detailsPlaceholder": "कृपया अंग्रेज़ी में भरें। उदाहरण के लिए: <br/>\nCoeliac disease, recent surgery, chronic pain",
      "label": "क्या आपको कोई अन्य चिकित्सीय स्थिति या चिंता है जिसके बारे में हमें जानना चाहिए?",
      "nextLabel": "$t(common:next): <b>दवाएं</b>",
      "title": "<h3>अन्य स्वास्थ्य स्थितियाँ (Other health conditions)</h3>"
    },
    "pacemaker": {
      "defibrillator": "डिफिब्रिलेटर",
      "detailsLabel": "यह किस प्रकार का है?",
      "label": "क्या आपके पास पेसमेकर या कोई अन्य प्रतिरोपित हृदय डिवाइस है?",
      "nextLabel": "$t(common:next): <b>ब्लड थिनर दवाएं</b>",
      "not-sure": "मुझे नहीं पता",
      "pacing": "पेसिंग",
      "title": "<h3>पेसमेकर या प्रत्यारोपित हृदय उपकरण (Pacemaker or implanted cardiac device)</h3>"
    },
    "pregnancy": {
      "label": "क्या आप वर्तमान में गर्भवती हैं – या संभवतः गर्भवती हो सकती हैं?",
      "nextLabel": "$t(common:next): <b>अन्य स्वास्थ्य स्थितियाँ</b>",
      "title": "<h3>गर्भावस्था (Pregnancy)</h3>"
    },
    "stroke": {
      "detailsPlaceholder": "कृपया अंग्रेज़ी में भरें। उदाहरण के लिए:<br/>\nStroke in 2021 – mild weakness on left side",
      "label": "क्या आपको कभी स्ट्रोक या मिनी-स्ट्रोक (TIA) हुआ है?",
      "nextLabel": "$t(common:next): <b>मिर्गी (Epilepsy)</b>",
      "title": "<h3>स्ट्रोक या छोटा स्ट्रोक (TIA)</h3>"
    },
    "weightHeight": {
      "cm": "cm",
      "height": "ऊंचाई",
      "kg": "kg",
      "nextLabel": "$t(common:next): <b>इम्प्लांट / धातु</b>",
      "text": "कृपया अपना अनुमानित वज़न और कद दर्ज करें।",
      "title": "<h3>वज़न और कद</h3><p>कृपया अपना अनुमानित वज़न और कद दर्ज करें।</p>",
      "weight": "वज़न"
    }
  },
  "text": "<p>हम लगभग पूरा कर चुके हैं।</p>\n<p>हमें आपके स्वास्थ्य, दवाओं और प्राथमिकताओं के बारे में कुछ सवाल पूछने हैं।</p>\n<p>आपकी देखभाल को प्रभावित कर सकने वाली किसी भी चीज़ को समझना हमारे लिए ज़रूरी है।</p>\n<p>अगर कुछ स्पष्ट करने की ज़रूरत पड़ी, तो हमारी टीम का कोई सदस्य आपकी प्रक्रिया से पहले आपसे संपर्क करेगा।</p>\n<p>इस अंतिम चरण में आमतौर पर <strong>10 मिनट</strong> से भी कम समय लगता है।</p>",
  "title": "स्वास्थ्य और प्राथमिकता से जुड़े प्रश्न"
}
